import React, { Fragment, useLayoutEffect, useState, useRef, useEffect, useContext, memo, useCallback, useMemo } from 'react';
import '../src/mixed-media.css';
import { Sticky } from './StandardComponents';
import onepager from '../src/imgs/Patent-1001-one-pager.jpg';
import { ReactParallax } from './ReactParallax';

export const MixedMedia = (props) => {

    // const programGallerySlideUp = props.gallery === "category" && props.videoChosen === false && props.searchText === "" && props.programimgsLoaded

    return (
      <div className={`mixed-media gallery-c 
        ${true ? "show" : "hide"}

      `}
        // style={{background: props.mainGalleryElementHoverId != null && props.categoryGalleryData[props.mainGalleryElementHoverId].background}}
      >
      <div className={`gallery ${true ? "show" : "hide"}`}>

      </div>
            <Sticky
                offsetSticky={"8vh"}
                fadeSticky={true}
                className={"sticky-category-gallery-header"}
                //stickyCallback={stickyCallback}
            >
                {(isSticky) => (
                    <div className={"category-gallery-header-c"}>
                        <h1 className={"category-gallery-header"}>
                            {["Introducing a new tool"]}
                        </h1>
                        <span className={`category-gallery-subheader ${isSticky ? "fade-out" : "fade-in"}`}>
                            {/* {category.plSubtitle} */}
                        </span>
                    </div>
                )}
            </Sticky>
          <Fragment>   
            <div className={`onepager`}>
            <ReactParallax
                src={onepager}
            >
            </ReactParallax>
            </div>
            {/* <img className={`onepager`}
                src={onepager}
            ></img> */}
            </Fragment>
        {/* } */}
      </div>
    )
  }

